import React from 'react';

import { Box, Breadcrumb, Heading } from '@primer/components'
import { Link } from "react-router-dom";

import WaveHero from '../../components/WaveHero';
import Seo from '../../components/Seo'


const SEO = <Seo title="Django code challenges" />

export default function ChallengeList(props) {
  return (
    <Box>
      { SEO }
      <WaveHero>
        <Box className="container-lg lead text-white pt-2 pb-9 pb-md-8 pt-md-8 pl-4 pl-md-0">
          <Breadcrumb>
            <Breadcrumb.Item as={Link} to={'/'} className="text-white">Home</Breadcrumb.Item>
            <br/>
          </Breadcrumb>
          <Heading className="mb-0 text-white" style={{ display: 'block' }}>Django challenges</Heading>
        </Box>
      </WaveHero>
      <div className="container-lg px-3 mb-9" style={{fontSize: "16px"}}>
        <ul className="list-style-none mt-8 col-md-8">
          { challenges.map(({title, description, link}) => (
              <li className="pb-8">
                <Link to={link}>
                  <Heading fontSize={5}>{title}</Heading>
                  <p className="f3 text-gray">{description}</p>
                  Start the challenge
                </Link>
              </li>
            ))
          }
        </ul>
      </div>
    </Box>
  );
}

const challenges = [
  {
    title: 'Security',
    description: 'Django security flaws risk your website, users, and reputation. Can you find and fix all the Django settings.py problems to improve security?',
    link: '/features/django/challenge/settings-security'
  },
  {
    title: 'Performance',
    description: 'Django ORM anti-patterns will slow down your web app. That harms user experience, SEO, and can even bring down production. Can you find and fix all the Django database query code smells?',
    link: '/features/django/challenge/database-queries'
  },
  {
    title: 'Maintainability',
    description: 'Anti-patterns hinder the maintainability of your codebase. This tech debt will slow down adding new features in future. Can you find and fix the tech debt?',
    link: '/features/django/challenge/models'
  },
]